import { LogoMark } from "~/components/brand/logo-mark";
import { cn } from "~/lib/utils";

type LogoSurface = "light" | "dark";

interface LogoProps {
  surface?: LogoSurface;
  compactOnMobile?: boolean;
  showTagline?: boolean;
}

export default function Logo({
  surface = "dark",
  compactOnMobile = false,
  showTagline = false,
}: LogoProps) {
  const markColor = surface === "light" ? "text-brand" : "text-white";

  return (
    <span
      className={cn(
        "inline-flex gap-2",
        showTagline ? "items-start" : "items-center",
      )}
      role="img"
      aria-label={
        showTagline
          ? "Rešimo Probleme, Može da ti bude bolje."
          : "Rešimo Probleme"
      }
    >
      <LogoMark
        weight="lockup"
        decorative
        className={cn("h-[25px] w-auto shrink-0 sm:h-[27px]", markColor)}
      />
      <span
        aria-hidden="true"
        className={cn(
          "flex flex-col text-base sm:text-lg",
          compactOnMobile && "hidden sm:flex",
        )}
      >
        <LogoText
          surface={surface}
          className="font-bold leading-none sm:leading-none"
        />
        {showTagline ? (
          <span
            className={cn(
              "mt-1 text-xs font-normal leading-tight",
              surface === "light" ? "text-muted-foreground" : "text-white/65",
            )}
          >
            Može da ti bude bolje.
          </span>
        ) : null}
      </span>
    </span>
  );
}

export function LogoText({
  surface = "dark",
  className,
}: {
  surface?: LogoSurface;
  className?: string;
}) {
  if (surface === "light") {
    return (
      <span className={cn("font-bold leading-none tracking-tight", className)}>
        <span className="text-brand-forest">rešimo</span>
        <span className="text-brand">probleme</span>
      </span>
    );
  }

  return (
    <span className={cn("font-bold leading-none tracking-tight", className)}>
      <span className="text-white">rešimo</span>
      {/* Opacity, not a brand hue: the ratified palette is one-hue,
          no-accent, so the split reads as weight (white vs. dimmed white)
          rather than a second color. */}
      <span className="text-white/65">probleme</span>
    </span>
  );
}
